import React from 'react';
import { token } from '@atlaskit/tokens';

export const MixedStatusIcon: React.JSX.Element = (
	<svg
		height="100%"
		version="1.1"
		viewBox="0 0 8 8"
		width="100%"
		xmlns="http://www.w3.org/2000/svg"
	>
		{/* Outer dark circle — fills everything, forms the dark ring border */}
		<circle fill={token('color.background.neutral.bold')} cx="4" cy="4" r="4" />
		{/* Left half of a smaller circle — creates the light half, leaves dark ring + dark right half */}
		<path fill={token('elevation.surface.overlay')} d="M4,2 A2,2 0 0,0 4,6 Z" />
	</svg>
);
